// PageBase component
/* eslint indent: 0, standard/no-callback-literal: 0 */

import React, { Component } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import async from 'async'
import app from '../../../app.jsx'

import eventfilters from '../../../lib/eventfilters.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import Sidebar from '../../layout/sidebar/sidebar.jsx'
import Help from '../../help/help/help.jsx'
import helpinfo from '../../help/help/info.json'
import helpinfonl from '../../help/help/infonl.json'
import helpinfode from '../../help/help/infode.json'
import DialogAlert from '../../dialog/dialog_alert/dialog_alert.jsx'
import Alert from '../../common/alert/alert.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import DialogTimeCardAdd from '../../../time/dialog/dialog_timecardadd/dialog_timecardadd.jsx'
import DialogTeamSelect from '../../team/dialog_team_select/dialog_team_select.jsx'
import AddButton from '../../common/add_button/add_button.jsx'
import SidebarUtil from '../../../lib/sidebarutil.jsx'
import DemoButton from '../../common/demo_button/demo_button.jsx'
import DialogTrail from '../../../common/dialog/dialog_trail/dialog_trail.jsx'
import DialogTeamBlocked from '../../../common/dialog/dialog_teamblocked/dialog_teamblocked.jsx'
import DialogSubscriptionUpgrade from '../../dialog/dialog_subscriptionupgrade/dialog_subscriptionupgrade.jsx'
import DialogDemoSubscriptionUpgrade from '../../dialog/dialog_demo_subscriptionupgrade/dialog_demo_subscriptionupgrade.jsx'
import Util from '../../../lib/util.jsx'
import TimeUtil from '../../../lib/timeutil.jsx'
import ConnectionUtil from '../../../lib/connectionutil.jsx'
import { NoTeamAvailableError } from '../../../../shared/errors/NoTeamAvailableError.js'
import { buildTimer } from '../../timer/timer.js'
import { buildTimerEvents } from '../../../../shared/util/timer/timerEvents.js'
import { isChatEnabled } from '../page_chat/utils.js'
import { Spinner } from '../../common/spinner'

class PageBase extends Component {
  state = {
    isLoading: false
  }

  constructor (props, ident, sidebarIdent, helpIdent, buttonSize) {
    super(props)

    this._bShowHelp = false
    this._pageIdent = ident
    this._buttonSize = buttonSize
    this._sidebarIdent = sidebarIdent
    this._helpinfo = this._getLanguage(helpIdent)
    this._eventHandlers = {}
    this._bStopTimerRunning = false
    this._pageData = {
      timer: {
        userTask: null
      },
      projects: [],
      userState: {
        favorites: this._getFavoritesFromCache()
      },
      userTeams: null,
      teams: [],
      bShowTeamSelect: false
    }

    this._fabButton = {
      required: false,
      hasClose: false,
      visible: false,
      animateOnce: true
    }

    this._bTeamExpired = app.isTeamExpired()
    this._bTeamTrail = app.isTrail()
    this._bTeamBlocked = app.isTeamBlocked()
    this.ignoreAutoSearch = false
    this._enableFbq = false
    this._defaultCountry = app.teamCountry === 'US' ? 'US' : 'NL'
    this._basePageReferences = {
      alert: React.createRef(),
      dialogTrail: React.createRef(),
      help: React.createRef(),
      logoutDialog: React.createRef(),
      refDialogSubscriptionUpgrade: React.createRef(),
      refFABButton: React.createRef(),
      refDemoButton: React.createRef()
    }
    this._bUnMounted = false

    const config = app.getConfig()
    if (config) {
      this._enableFbq = !!(config.fbq && config.fbq.enabled)
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  render () {
    const _className = classnames(
      'page',
      {
        page_hashelp: this._bShowHelp,
        page_nohelp: !this._bShowHelp,
        devmode: app.isDevModeEnabled()
      },
      `page-${this._pageIdent}`
    )
    const bCollapse = SidebarUtil.getSidebarExpand()

    const contentClass = this.getContentClassname()
    const pagecontClass = classnames(
      'pagecontent',
      {
        sbarcollapsed: bCollapse
      },
      contentClass
    )
    const bMultipleTeams =
      this._pageData.userTeams && this._pageData.userTeams.length > 1
    const recaptchaEnabled = app.config.recaptcha.enabled
    const mobile = app.isMobile

    return (
      <>
        <div className={_className}>
          {this._helpinfo && (
            <Help
              ref={this._basePageReferences.help}
              info={this._helpinfo}
              onClose={this._onCloseHelp.bind(this)}
            />
          )}
          <div
            className='pagewrap'
            onClick={this._bShowHelp ? this._onCloseHelp.bind(this) : null}
          >
            {!mobile && this.renderSidebar()}
            <div className={pagecontClass}>
              {this.renderHeader()}
              {
                this.state.isLoading ? (
                  <div className='spinner-container '>
                    <Spinner />
                  </div>
                ) : (
                  <div className='page-inner'>{this.renderContent()}</div>
                )
              }
            </div>
            {this._bTeamTrail &&
              !app.isDemo &&
              this._pageIdent !== 'setting-subscription' && (
                <DemoButton
                  title='common.team.subscribeButton'
                  onClick={this._onClickSubscribe.bind(this)}
                  ref={this._basePageReferences.refDemoButton}
                />
              )}
          </div>
          <DialogAlert
            ref={this._basePageReferences.logoutDialog}
            title='common.dialogLogout.logoutTitle'
            message='common.dialogLogout.logoutInfo'
            onOk={this._onClickLogout.bind(this)}
            showSwitchAccount={bMultipleTeams}
            onSwitchAccount={this._onClickSwitchAccount.bind(this)}
          />
          {this._renderDialogTimeCardAdd()}
          {this._renderTeamSelect()}
          {this._renderFABButton()}
          {this._renderUpgradeDialog()}
          <DialogTrail
            ref={this._basePageReferences.dialogTrail}
            recaptchaEnabled={recaptchaEnabled}
            onSubmit={this._onSubmitDemoRegister.bind(this)}
            onUpdateEmail={this._onUpdateDemoEmail.bind(this)}
            onResendEmail={this._onResendDemoEmail.bind(this)}
            onShowError={this._onShowError.bind(this)}
            onClose={this._onCloseDialogTrail.bind(this)}
            checkUserExists={this._checkUserExists.bind(this)}
          />
        </div>
        <Alert ref={this._basePageReferences.alert} />
      </>
    )
  }

  renderContent () {
    return null
  }

  renderHeader () {
    return null
  }

  getContentClassname () {
    return null
  }

  showInfo (msgIdent) {
    if (this._basePageReferences.alert.current) {
      this._basePageReferences.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'info'
      )
    }
  }

  showError (msgIdent, bTranslate = true, options = null, msgData = {}) {
    if (this._basePageReferences.alert.current) {
      this._basePageReferences.alert.current.onShow(
        bTranslate ? IntlUtil.convertMessage(msgIdent, msgData) : msgIdent,
        'error',
        options
      )
    }
  }

  showWarning (msgIdent) {
    if (this._basePageReferences.alert.current) {
      this._basePageReferences.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'warning'
      )
    }
  }

  showSuccess (msgIdent, bTranslate = true, options = null, msgData = {}) {
    if (this._basePageReferences.alert.current) {
      this._basePageReferences.alert.current.onShow(
        bTranslate ? IntlUtil.convertMessage(msgIdent, msgData) : msgIdent,
        'success',
        options
      )
    }
  }

  /* Event Handlers */
  _onShowError (msgIdent) {
    this.showError(msgIdent)
  }

  _onSubmitDemoRegister (teamData, bUserExists, callback) {
    if (bUserExists) {
      this._validatePassword(teamData.email, teamData.password, loginRes => {
        if (loginRes) {
          this._signupDemoTeam(teamData, bUserExists, callback)
        } else {
          this.showError('user.login.msgInvalidValues')
        }
      })
    } else {
      this._signupDemoTeam(teamData, bUserExists, callback)
    }
  }

  _signupDemoTeam (teamData, bUserExists, callback) {
    app
      .service('/api/team/demosignup')
      .create(teamData)
      .then(_sigupRes => {
        this._callFacebookPixel()
        if (bUserExists) {
          if (
            !this._bUnMounted &&
            this._basePageReferences.dialogTrail.current
          ) {
            this._basePageReferences.dialogTrail.current.hide()
          }
          window.location.href = '/'
        } else if (callback) {
          callback(true) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(signupErr => {
        app.debug('PageBase: _onSubmitDemoRegister err', signupErr)
        if (signupErr.message) {
          if (
            signupErr.message === 'Team with same name already exists' &&
            this._basePageReferences.alert.current
          ) {
            this._basePageReferences.dialogTrail.current.showError(
              'user.signupTeam.msgErrTeamAlreadyExists'
            )
          }
        }
        if (callback) {
          callback(false)
        }
      })
  }

  _onUpdateDemoEmail (email) {
    app
      .service('/api/team/demosignup')
      .patch(app.getTeamId(), { email: email })
      .then(_updateRes => {})
      .catch(updateErr => {
        app.debug('PageBase: _onUpdateDemoEmail err', updateErr)
      })
  }

  _onResendDemoEmail (email) {
    app
      .service('/api/team/demosignup')
      .update(app.getTeamId(), { email: email })
      .then(_res => {})
      .catch(err => {
        app.debug('PageBase: _onResendDemoEmail err', err)
      })
  }

  _onCloseDialogTrail () {
    this.ignoreAutoSearch = false
  }

  _callFacebookPixel () {
    if (!this._enableFbq) {
      return false
    }

    let tries = 1
    this._loadFbq()
    this._fbqScriptTimer = window.setInterval(() => {
      const fbq = window.fbq
      if (fbq || tries > 10) {
        window.clearInterval(this._fbqScriptTimer)

        if (fbq) {
          fbq('init', '784623004996468')
          fbq('track', 'PageView')
          fbq('track', 'Lead')
        }
      }

      tries++
    }, 2000)
  }

  _onCloseHelp () {
    this._bShowHelp = false
    if (this._basePageReferences.help.current) {
      this._basePageReferences.help.current.hide()
    }
    this.forceUpdate()
  }

  _onClickDemoLogo () {
    const config = app.getConfig()
    if (config && config.siteurl) {
      let countryPath = '/'
      if (app.teamCountry === 'NL') {
        countryPath = '/nl/'
      } else if (app.teamCountry === 'DE') {
        countryPath = '/de/'
      } else if (app.teamCountry === 'US') {
        countryPath = '/us/'
      }
      window.location.href = `${config.siteurl}${countryPath}?demo=true`
    }
  }

  _onChangeTeam = teamId => {
    this._onTeamSelect(teamId)
  }

  _onToggleDevMode = () => {
    app.toggleDevMode()
    app.pageContainer.refresh()
  }

  _onChangeSidebar (pageIdent) {
    if (pageIdent === 'planner') {
      app.changePage(this._getUserFavoriteTab('planner') || 'planner')
    } else if (pageIdent === 'expenses') {
      app.changePage(this._getUserFavoriteTab('expanse') || 'expenses')
    } else if (pageIdent === 'invoices') {
      app.changePage(this._getUserFavoriteTab('invoice') || 'invoices')
    } else if (pageIdent === 'setting-user') {
      app.changePage(this._getUserFavoriteTab('settings') || 'setting-user')
    } else if (pageIdent === 'user-profile') {
      app.changePage(this._getUserFavoriteTab('user') || 'user-profile')
    } else {
      if (pageIdent === 'logout') {
        if (this._basePageReferences.logoutDialog.current) {
          this._basePageReferences.logoutDialog.current.show()
        }
      } else {
        const disabledPages = ['time', 'invoices']
        if (_.findIndex(disabledPages, pageIdent) < 0) {
          app.changePage(pageIdent)
        }
      }
    }
  }

  _onCollapse (bCollapse) {
    this._updateSidebarState(bCollapse)
    SidebarUtil.setSidebarExpand(bCollapse)
    this.forceUpdate()
  }

  _updateSidebarState (bCollapse) {
    const updateObj = {
      state: this._pageData.userState.state || {}
    }
    if (updateObj.state.showSidebarExpand === undefined) {
      updateObj.state.showSidebarExpand = false
    }
    updateObj.state.showSidebarExpand = bCollapse
    if (this._pageData.userState.id) {
      app
        .service('/api/user/state')
        .patch(this._pageData.userState.id, updateObj, {})
        .then(_result => {})
        .catch(err => {
          app.debug('PageBase: _updateSidebarState err', err)
        })
    } else {
      const createObj = {
        userId: app.loggedInId,
        state: updateObj.state
      }
      app
        .service('/api/user/state')
        .create(createObj)
        .then(_result => {})
        .catch(err => {
          app.debug('PageBase: _createUserState err', err)
        })
    }
  }

  _onClickSignup (ev) {
    ev.preventDefault()
    this.ignoreAutoSearch = true
    if (!this._bUnMounted && this._basePageReferences.dialogTrail.current) {
      this._basePageReferences.dialogTrail.current.show()
    }
  }

  _onClickSubscribe (ev) {
    ev.preventDefault()
    app.changePage('setting-subscription')
  }

  /* Private functions */
  _initTimerEvents (callback) {
    this._eventHandlers.timerCreated = this._eventReloadTimer.bind(
      this,
      'Created',
      callback
    )
    this._eventHandlers.timerUpdated = this._eventReloadTimer.bind(
      this,
      'Updated',
      callback
    )
    this._eventHandlers.timerRemoved = this._eventReloadTimer.bind(
      this,
      'Removed',
      callback
    )
    this._eventHandlers.timerPatched = this._eventReloadTimer.bind(
      this,
      'Patched',
      callback
    )

    const userTaskService = app.service('/api/usertask')
    userTaskService.on('created', this._eventHandlers.timerCreated)
    userTaskService.on('updated', this._eventHandlers.timerUpdated)
    userTaskService.on('removed', this._eventHandlers.timerRemoved)
    userTaskService.on('patched', this._eventHandlers.timerPatched)
  }

  _releaseTimerEvents () {
    const userTaskService = app.service('/api/usertask')
    userTaskService.off('created', this._eventHandlers.timerCreated)
    userTaskService.off('updated', this._eventHandlers.timerUpdated)
    userTaskService.off('removed', this._eventHandlers.timerRemoved)
    userTaskService.off('patched', this._eventHandlers.timerPatched)

    this._eventHandlers.userTaskService = null
    this._eventHandlers.userTaskService = null
    this._eventHandlers.userTaskService = null
    this._eventHandlers.userTaskService = null
  }

  _eventReloadTimer (eventName, callback, eventData) {
    if (eventfilters.teamFilter(eventData)) {
      app.debug(`-- Event - PageBase - UserTask - ${eventName} --`)
      if (callback) {
        callback(eventData)
      }
    }
  }

  _initQuickbookExpenseEvents () {
    this._eventHandlers.quickbookExpenseCreated = this._eventReloadQuickbookExpense.bind(
      this
    )

    const userTaskService = app.service('/api/quickbook/expense')
    userTaskService.on('created', this._eventHandlers.quickbookExpenseCreated)
  }

  _releaseQuickbookExpenseEvents () {
    const userTaskService = app.service('/api/quickbook/expense')
    userTaskService.off('created', this._eventHandlers.quickbookExpenseCreated)

    this._eventHandlers.quickbookExpenseCreated = null
  }

  _eventReloadQuickbookExpense (eventData) {
    if (
      eventData &&
      eventData.quickbook &&
      eventfilters.teamFilter(eventData)
    ) {
      app.debug('-- Event - PageBase - Quickbook - Created --')
      const msgData = {
        supplier: eventData.supplierName,
        invoiceNo: eventData.invoiceNo
      }
      if (eventData.quickbook.status === 'Completed') {
        this.showSuccess(
          'expense.view.copyToQuickbookSuccessInfo',
          true,
          { timeout: 10000 },
          msgData
        )
      } else if (eventData.quickbook.message) {
        msgData.message = eventData.quickbook.message
        this.showError(
          'expense.view.copyToQuickbookErrorInfo',
          true,
          { timeout: 10000, html: true },
          msgData
        )
      } else {
        msgData.message = '-'
        this.showError(
          'expense.view.copyToQuickbookErrorMsg',
          true,
          { timeout: 10000, html: true },
          msgData
        )
      }

      // If the quickbook is not completed and has error, show the edit form
      if (eventData.quickbook.status !== 'Completed') {
        if (this._openExpense !== undefined) {
          this._openExpense(eventData.id)
        }
      }
    }
  }

  _getUserTeamList () {
    try {
      const teams = app.availableTeams
      const currentTeamId = app.getTeam() ? app.getTeam().id : ''
      return [
        app.getTeam(),
        ...teams.filter(team => `${team.id}` !== currentTeamId)
      ]
    } catch (error) {
      if (error instanceof NoTeamAvailableError) {
        app.authentication.logout('/')
        return []
      } else {
        throw error
      }
    }
  }

  renderSidebar () {
    const teams = this._getUserTeamList()
    const showChatButton = isChatEnabled()

    return (
      <div className='pagesidebar'>
        <Sidebar
          navigateTo={this._onChangeSidebar.bind(this)}
          pageId={this._sidebarIdent}
          isMobile={app.isMobile}
          isCollapsed={SidebarUtil.getSidebarExpand()}
          teams={teams}
          activeTeamId={app.teamId}
          showTimer={app.hasUserTask}
          showRecurringInvoice={app.hasRecurringInvoice}
          pin={this._onCollapse.bind(this)}
          isDemo={app.isDemo}
          onClickDemoLogo={this._onClickDemoLogo.bind(this)}
          changeTeam={this._onChangeTeam}
          toggleDevMode={app.canAccessDevMode() ? this._onToggleDevMode.bind(this) : null}
          showChatButton={showChatButton}
        />
      </div>
    )
  }

  _renderDialogTimeCardAdd () {
    return (
      <DialogTimeCardAdd
        projects={this._pageData.projects}
        onSearchActivity={this._onSearchActivity.bind(this)}
      />
    )
  }

  async _onClickLogout (ev) {
    ev.preventDefault()

    const timer = this._getTimer()
    await timer.pause(app)

    app.logout()
  }

  _onClickSwitchAccount (ev) {
    ev.preventDefault()
    this._onShowSwitchAccount()
  }

  _onShowSwitchAccount () {
    const timer = this._getTimer()

    async.series(
      [
        done => {
          Promise.resolve(timer.pause(app)).then(() => done())
        },
        done => {
          const teamIds = []
          if (this._pageData.userTeams) {
            this._pageData.userTeams.map(userTeam => {
              teamIds.push(userTeam.teamId)
            })
          }

          const params = {
            query: {
              _id: teamIds,
              active: true,
              $or: [
                { demoInfo: null },
                { 'demoInfo.active': false, 'demoInfo.confirmCode': '' }
              ]
            }
          }

          app
            .service('/api/team')
            .find(params)
            .then(teamRes => {
              if (teamRes.total === 0) {
                this.showError('No teams available')
              } else if (teamRes.total === 1) {
                this._onTeamSelect(teamRes.data[0].id)
              }

              this._pageData.teams = teamRes.data
              done(null)
            })
            .catch(teamErr => {
              done(teamErr)
            })
        }
      ],
      (err, _res) => {
        if (err) {
          app.debug('### Page Base: _getTeamData ', err)
          this.showError('Error in getting team list')
        } else {
          this._pageData.bShowTeamSelect = true
          this.setState({ dataDate: new Date() })
        }
      }
    )
  }

  _renderTeamSelect () {
    if (
      this._pageData.bShowTeamSelect &&
      this._pageData.teams &&
      this._pageData.teams.length > 1
    ) {
      return (
        <DialogTeamSelect
          teams={this._pageData.teams}
          onSelect={this._onTeamSelect.bind(this)}
        />
      )
    }

    return ''
  }

  _onTeamSelect (teamId) {
    return app.setTeam(teamId).then(() => {
      this._pageData.bShowTeamSelect = false
      this._pageData.teams = []
      app.redirect('/')
    })
  }

  _updatePageState (pageState, callback = null) {
    if (pageState) {
      const saveObjectPageState = this._getSaveObjectPageState(pageState)

      if (this._pageData.userState && this._pageData.userState.id) {
        this._updateUserState(
          this._pageData.userState.id,
          saveObjectPageState,
          callback
        )
      } else {
        this._createUserState(saveObjectPageState, callback)
      }
    }
  }

  _getSaveObjectPageState (pageState) {
    return pageState
  }

  _updateUserState (userStatId, pageState, callback = null) {
    const updateObj = {
      state: this._pageData.userState.state || {}
    }
    updateObj.state[this._pageIdent] = pageState

    this._callUserStateUpdate(userStatId, updateObj, callback)
  }

  _createUserState (pageState, callback = null) {
    const createObj = {
      userId: app.loggedInId,
      state: {}
    }

    createObj.state[this._pageIdent] = pageState

    this._callUserStateCreate(createObj, callback)
  }

  _updateUserStateFavorite (ident, value) {
    const userState = this._pageData.userState
    if (userState && userState.id) {
      const updateObj = {
        favorites: userState.favorites || {}
      }

      updateObj.favorites[ident] = value

      this._pageData.userState.favorites = updateObj.favorites

      this._setFavoritesFromCache(updateObj.favorites)
      this._callUserStateUpdate(userState.id, updateObj)
    } else {
      const createObj = {
        userId: app.loggedInId,
        favorites: {
          [ident]: value
        }
      }

      this._pageData.userState = createObj

      this._setFavoritesFromCache(createObj.favorites)
      this._callUserStateCreate(createObj)
    }
  }

  _getUserFavoriteTab (ident) {
    const userState = this._pageData.userState

    if (userState && userState.favorites) {
      return userState.favorites[ident] || ''
    }

    return ''
  }

  _getFavoritesFromCache () {
    return app.getAsObject('userFavorites') || null
  }

  _setFavoritesFromCache (favorites) {
    app.setAsObject('userFavorites', favorites)
  }

  _callUserStateCreate (createObj, callback = null) {
    app
      .service('/api/user/state')
      .create(createObj)
      .then(result => {
        this._pageData.userState = result
        if (callback) {
          callback()
        }
      })
      .catch(err => {
        app.debug('PageBase: _callUserStateCreate err', err)
        if (callback) {
          callback()
        }
      })
  }

  _callUserStateUpdate (userStatId, updateObj, callback = null) {
    app
      .service('/api/user/state')
      .patch(userStatId, updateObj, {})
      .then(result => {
        this._pageData.userState = result
        if (callback) {
          callback()
        }
      })
      .catch(err => {
        app.debug('PageBase: _callUserStateUpdate err', err)
        if (callback) {
          callback()
        }
      })
  }

  _onUserStateRecieved (_userState) {
    // Can be overridden
  }

  _getPageUserState (userState) {
    const state = userState && userState.state ? userState.state : null
    return state && state[this._pageIdent] !== undefined
      ? state[this._pageIdent]
      : null
  }

  _getLanguage (helpIdent) {
    const userLanguage = IntlUtil.getLang()

    if (userLanguage === 'nl') {
      return helpinfonl[helpIdent]
    } else if (userLanguage === 'de') {
      return helpinfode[helpIdent]
    } else {
      return helpinfo[helpIdent]
    }
  }

  _getPageData (callback) {
    const params = {
      query: {
        userId: app.loggedInId
      }
    }

    app
      .service('/api/page/common')
      .find(params)
      .then(result => {
        this._pageData.userState = result.userState
        this._pageData.timer.userTask = result.userTask
        this._pageData.userTeams = result.userTeams
        this._onUserStateRecieved(this._pageData.userState)

        // Set user task is active or not
        app.setUserTask(!!result.userTask)

        // Set recurring invoice created
        app.setHasRecurringInvoice(!!result.hasRecurringInvoice)

        // Validate user task, one timer can run on current date
        this._validateUserTask()

        // Set Sidebar Expand state to sidebarUtil
        if (result.userState && result.userState.state) {
          SidebarUtil.setSidebarExpand(
            !!result.userState.state.showSidebarExpand
          )
        }

        callback(null)
      })
      .catch(err => {
        app.debug('PageBase: _getPageData err', err)
        if (err && err.message === 'You are not authenticated.') {
          if (app.loggedInId) {
            window.location.reload()
          } else {
            app.logout()
          }
        } else {
          callback(err)
        }
      })
  }

  // This method is a Promise wrapper for _getPageData. Subclasses can call this to get the same
  // data, without all the callback hell.
  _getPageDataWithPromises () {
    return new Promise((resolve, reject) => {
      this._getPageData(err => {
        if (err) {
          reject(err)
        } else {
          resolve(null)
        }
      })
    })
  }

  async _getInternalExpensesDashboardUrl () {
    try {
      const teamId = app.getTeamId()
      const result = await app
        .service('/api/internal-expenses/get-expense-dashboard-url')
        .get(teamId)

      if (!result || !result.url) return null

      return result.url
    } catch (error) {
      console.log('Could not fetch the internal expenses dashboard url!', error)
      return null
    }
  }

  _onPageDataRecieved (pageData) {
    this._pageData.userState = pageData.userState
    this._pageData.timer = pageData.timer
    this._pageData.userTeams = pageData.userTeams
    this._onUserStateRecieved(this._pageData.userState)

    // Set user task is active or not
    app.setUserTask(!!pageData.timer.userTask)

    // Set recurring invoice created
    app.setHasRecurringInvoice(!!pageData.hasRecurringInvoice)

    // Validate user task, one timer can run on current date
    this._validateUserTask()

    // Set Sidebar Expand state to sidebarUtil
    if (pageData.userState && pageData.userState.state) {
      SidebarUtil.setSidebarExpand(!!pageData.userState.state.showSidebarExpand)
    }
  }

  _updateGridState (pageIdent, keyword, filters, callback) {
    const data = {
      identifier: pageIdent,
      action: 'filteradded',
      userId: app.loggedInId,
      history: {
        keyword: keyword || '',
        filters: []
      }
    }

    filters.map(filter => {
      if (filter.value && filter.ident) {
        data.history.filters.push({
          ident: filter.ident,
          value: filter.value,
          text: filter.text
        })
      }
    })

    if (data.history.keyword || data.history.filters.length > 0) {
      return app
        .service('/api/page/gridstate')
        .create(data)
        .then(() => {
          if (callback) {
            callback()
          }
        })
        .catch(err => {
          app.debug('PageBase: _updateGridState - Error: ', err)
        })
    }
  }

  _clearGridState (pageIdent) {
    const data = {
      identifier: pageIdent,
      action: 'filtercleared',
      userId: app.loggedInId
    }

    return app
      .service('/api/page/gridstate')
      .create(data)
      .then(() => {})
      .catch(err => {
        app.debug('PageBase: _updateGridState - Error: ', err)
      })
  }

  _reloadGridState (callback) {
    const stateParams = {
      query: {
        identifier: this._pageIdent,
        userId: app.loggedInId
      }
    }

    return app
      .service('/api/page/gridstate')
      .find(stateParams)
      .then(gridState => {
        if (callback) {
          callback(gridState)
        }
      })
      .catch(err => {
        app.debug('PageBase: _reloadGridState - Error: ', err)
      })
  }

  async _validateUserTask () {
    if (this._bStopTimerRunning) {
      return
    }

    // If timer is paused, and it is started in previous days,
    // Validate the date and stop the timer
    const timer = this._getTimer()
    if (
      timer.isPaused() &&
      timer.TimeCard()
    ) {
      const timeCard = timer.TimeCard()
      const timerDate = new Date(timeCard.createdOn)
      const timerTargetDate = new Date(
        timerDate.getFullYear(),
        timerDate.getMonth(),
        timerDate.getDate() + 1,
        0,
        0,
        0
      )

      const targetTime = timerTargetDate.getTime()
      const currDate = new Date().getTime()

      if (currDate >= targetTime) {
        // Timer associated with project and activity, stop the timer
        // Else remove it
        if (timeCard.projectId && timeCard.activityId) {
          await timer.stop(app)
          this._bStopTimerRunning = false
        } else {
          this._onDeleteUserTaskAndTimecard(timer, timeCard, () => {
            this._bStopTimerRunning = false
          })
        }

        this._pageData.timer.userTask = null
        app.setUserTask(false)
      }
    }
  }

  async _stopAndCreateNewTimeCard () {
    if (this._bStopTimerRunning) {
      return
    }

    this._bStopTimerRunning = true
    const timer = this._getTimer()

    if (timer.isStarted() && timer.TimeCard()) {
      const timeCard = timer.TimeCard()
      if (timeCard.projectId && timeCard.activityId) {
        await timer.stop(app)
        this._bStopTimerRunning = false
      } else {
        this._onDeleteUserTaskAndTimecard(timer, timeCard, () => {
          this._bStopTimerRunning = false
        })
      }
    }
  }

  _createTimecardFromExisting (timeCard, bStartTimer) {
    app
      .service('/api/timecard')
      .get(timeCard.id)
      .then(timecardRes => {
        if (timecardRes) {
          const createData = Util.removeObjectKeys(_.cloneDeep(timeCard), [
            'id',
            'project',
            'timeTaken',
            'index',
            'activityItem',
            'task'
          ])
          delete createData.favouriteId
          delete createData.isFavorite
          createData.userId = app.loggedInId
          createData.createdOn = new Date()

          TimeUtil.createTimeCard(createData, async createRes => {
            if (bStartTimer) {
              const timer = this._getTimer()
              const timerEvents = buildTimerEvents(app)
              if (timer.doesRelateToTimeCardId(createRes.id)) {
                await timer.start(app)
                this._bStopTimerRunning = false
              } else {
                timerEvents
                  .createTimerFromTimeCard(createRes, app.loggedInId)
                  .then(userTaskRes => {
                    this._pageData.timer.userTask = userTaskRes
                    this._bStopTimerRunning = false
                  })
                  .catch(err =>
                    app.debug('PageBase: _createTimecardFromExisting', err)
                  )
              }
            }
          })
        }
      })
      .catch(removeErr => {
        app.debug(
          'PageTime: _createTimecardFromExisting Timecard Error',
          removeErr
        )
      })
  }

  _onDeleteUserTaskAndTimecard (userTask, timecard, callback) {
    if (!timecard || !timecard.id) {
      return false
    }

    // Remove timecard and remove timer
    this._removeTimerAndTimeCard(timecard.id, () => {
      callback()
    })
  }

  _removeTimerAndTimeCard (timeCardId, callback) {
    const timer = this._getTimer()
    const data = {
      timeCardId: timeCardId,
      userTaskId: timer.ID()
    }

    app
      .service('/api/timecard/closetimer')
      .create(data)
      .then(_res => {
        callback()
      })
      .catch(removeErr => {
        app.debug('PageBase: _removeTimerAndTimeCard Error', removeErr)
      })
  }

  _createUserTask (userTask, callback) {
    const timerEvents = buildTimerEvents(app)
    timerEvents.createTimer(userTask)
      .then(userTaskRes => {
        if (callback) {
          callback(userTaskRes)
        }
      })
      .catch(err => {
        app.debug('PageBase: _createUserTask Error', err)
      })
  }

  _updateUserTaskStatus (userTaskId, status, callback) {
    const timerEvents = buildTimerEvents(app)
    timerEvents.update(userTaskId, { status })
      .then(userTaskRes => {
        if (callback) {
          callback(userTaskRes)
        }
      })
      .catch(err => {
        app.debug('PageBase: _updateUserTaskStatus Error', err)
        if (callback) {
          callback(null)
        }
      })
  }

  _onSearchActivity (projectId, callback) {
    const itemParams = {
      query: {
        projectId: projectId,
        type: { $in: ['time-activity'] },
        $select: ['title', 'phaseNo', 'projectId'],
        $client: {
          subObjects: {
            project: ['budget']
          }
        }
      }
    }

    app
      .service('/api/project/budgetitem')
      .find(itemParams)
      .then(itemRes => {
        if (itemRes) {
          const options = itemRes.data.map(obj => {
            const phases = obj.project.budget.phases
            const phaseName =
              phases && phases.length > 0 ? phases[obj.phaseNo - 1].title : ''
            const title =
              phaseName === '' ? obj.title : `${obj.title} - ${phaseName}`
            return { label: title, value: obj.id }
          })

          callback(options)
        } else {
          callback([]) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(err => {
        app.debug('PageBase: _onSearchActivity Error', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }

  _checkUserExists (email, callback) {
    if (email) {
      const userParams = { query: { email: email } }
      app
        .service('/api/users')
        .find(userParams)
        .then(userRes => {
          if (userRes && userRes.data && userRes.data.length > 0) {
            callback(true) // eslint-disable-line standard/no-callback-literal
          } else {
            callback(false) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(userErr => {
          app.debug('### PageBase: _checkUserExists ', userErr)
          callback(false) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback(false) // eslint-disable-line standard/no-callback-literal
    }
  }

  /** Filter Search Handler Functions */
  _onCommonFilterContactSearch (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          company: { $regex: pattern, $options: 'i' },
          $select: ['_id', 'company', 'rateMarkup', 'archived'],
          $limit: 25
        }
      }

      app.debug(
        'PageBase: _onCommonFilterContactSearch ',
        this._pageIdent,
        keyword
      )
      app
        .service('/api/contact')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(obj => ({
              label: obj.company,
              value: obj.id,
              rateMarkup: obj.rateMarkup,
              bArchived: obj.archived
            }))

            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug(
            'PageBase: _onCommonFilterContactSearch ERROR ',
            this._pageIdent,
            err
          )
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onCommonFilterTagSearch (keyword, excludeTags, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          objectType: 'project',
          title: { $regex: pattern, $options: 'i' },
          $select: ['title'],
          $limit: 25
        }
      }

      if (excludeTags && excludeTags.length > 0) {
        params.query.title.$nin = excludeTags
      }

      app.debug('PageBase: _onCommonFilterTagSearch ', this._pageIdent, keyword)
      app
        .service('/api/tag')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(obj => ({
              label: obj.title,
              value: obj.title
            }))
            callback(options)
          } else {
            callback([]) // eslint-disable-line standard/no-callback-literal
          }
        })
        .catch(err => {
          app.debug(
            'PageBase: _onCommonFilterTagSearch ERROR ',
            this._pageIdent,
            err
          )
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  _onCommonFilterProjectSearch (keyword, bEstimate, callback) {
    if (keyword) {
      let ignoreStatus = null
      if (bEstimate) {
        ignoreStatus = ['estimate']
      }

      this._searchProjects(keyword, ignoreStatus, false, null, callback)
    } else {
      callback([])
    }
  }

  _onTimeProjectSearch (keyword, bEstimate, userId, callback) {
    const ignoreStatus = ['estimate', 'closed', 'completed']
    const bHasTimeActivity = true

    const params = {
      query: {
        project: {
          keyword: keyword,
          ignoreStatus: ignoreStatus,
          bHasTimeActivity: bHasTimeActivity,
          filterUserId: userId
        }
      }
    }

    app
      .service('/api/options/project')
      .find(params)
      .then(result => {
        if (result.projectOptions && result.projectOptions.length > 0) {
          callback(result.projectOptions)
        } else {
          callback([])
        }
      })
      .catch(err => {
        app.debug('PageBase: _onTimeProjectSearch ERROR ', this._pageIdent, err)
        callback([])
      })
  }

  _searchProjects (
    keyword,
    ignoreStatus,
    bHasTimeActivity,
    contactIds,
    callback
  ) {
    const params = {
      query: {
        $select: ['_id', 'title', 'contactId']
      }
    }

    const bIncludeContacts = contactIds && contactIds.length > 0
    if (bIncludeContacts) {
      params.query.$client = {
        subObjects: {
          contact: ['company']
        }
      }
      params.query.contactId = contactIds
    } else if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      params.query.title = { $regex: pattern, $options: 'i' }
    }

    if (ignoreStatus && ignoreStatus.length > 0) {
      params.query.status = { $nin: ignoreStatus }
    }

    if (bHasTimeActivity) {
      params.query['budget.noActiveTimeActivities'] = { $gt: 0 }
    }

    app
      .service('/api/project')
      .find(params)
      .then(result => {
        if (result.data) {
          const options = result.data.map(obj => {
            const title = bIncludeContacts
              ? `${obj.title} - ${obj.contact ? obj.contact.company : ''}`
              : obj.title
            return { label: title, value: obj.id }
          })
          callback(options)
        } else {
          callback([])
        }
      })
      .catch(err => {
        app.debug('PageBase: _searchProjects ERROR ', this._pageIdent, err)
        callback([])
      })
  }

  _onCommonFilterUserSearch (keyword, callback) {
    if (keyword) {
      const pattern = keyword
        .replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        .replace(/\$/g, '$$$$')
      const params = {
        query: {
          teamId: app.getTeamId(),
          $or: [
            { firstName: { $regex: pattern, $options: 'i' } },
            { lastName: { $regex: pattern, $options: 'i' } }
          ],
          $select: ['userId', 'firstName', 'lastName'],
          $limit: 25
        }
      }

      app.debug(
        'PageBase: _onCommonFilterUserSearch ',
        this._pageIdent,
        keyword
      )
      app
        .service('/api/users/team')
        .find(params)
        .then(result => {
          if (result.data) {
            const options = result.data.map(obj => {
              return { label: obj.displayName, value: obj.userId }
            })
            callback(options)
          } else {
            callback([])
          }
        })
        .catch(err => {
          app.debug(
            'PageBase: _onCommonFilterUserSearch ERROR ',
            this._pageIdent,
            err
          )
          callback([]) // eslint-disable-line standard/no-callback-literal
        })
    } else {
      callback([]) // eslint-disable-line standard/no-callback-literal
    }
  }

  /* Contact functions */
  _commonCreateContact (name, callback) {
    app.debug('PageBase: _commonCreateContact ', this._pageIdent, name)
    const createObj = {
      company: name,
      archived: false
    }
    const params = {
      query: {
        $client: {
          avatarGenerate: true
        }
      }
    }

    app
      .service('/api/contact')
      .create(createObj, params)
      .then(result => {
        if (result) {
          callback(result.id)
        } else {
          callback(null)
        }
      })
      .catch(err => {
        app.debug('PageBase: _commonCreateContact ERROR ', this._pageIdent, err)
        callback(null)
      })
  }

  /* If `this._pageData.timer.userTask` is null, _getTimer returns a null object,
  so clients don't need to do the null checks themselves. */
  _getTimer () {
    return buildTimer(this._pageData.timer.userTask)
  }

  /* Subscription Upgrade */
  _renderUpgradeDialog () {
    if (!app.isDemo && this._pageIdent !== 'setting-subscription') {
      if (this._bTeamTrail && this._bTeamExpired) {
        return (
          <DialogDemoSubscriptionUpgrade
            active
            onUpgrade={this._onDemoUpgradeClick.bind(this)}
            onRequestDemo={this._onRequestDemoClick.bind(this)}
          />
        )
      } else if (this._bTeamExpired) {
        return (
          <DialogSubscriptionUpgrade
            ref={this._basePageReferences.refDialogSubscriptionUpgrade}
            active
            isTeamTrail={this._bTeamTrail}
            onUpgrade={this._onUpgradeClick.bind(this)}
          />
        )
      } else if (this._bTeamBlocked && app.teamCountry === 'US') {
        return <DialogTeamBlocked active />
      }
    }

    return ''
  }

  _onDemoUpgradeClick (startEmpty) {
    const teamId = app.getTeamId()

    app
      .service('/api/team')
      .patch(teamId, { startEmpty: startEmpty })
      .then(_res => {
        app.changePage('setting-subscription')
      })
      .catch(err => {
        app.debug('PageBase: _onDemoUpgradeClick err', err)
      })
  }

  _onRequestDemoClick () {
    const config = app.getConfig()
    if (config && config.siteurl) {
      window.location.href = config.siteurl + '/?demo=true'
    }
  }

  _onUpgradeClick () {
    if (this._basePageReferences.refDialogSubscriptionUpgrade.current) {
      this._basePageReferences.refDialogSubscriptionUpgrade.current.hide()
    }
    app.changePage('setting-subscription')
  }

  /* FAB Button Functions */
  _renderFABButton () {
    if (!this._fabButton.required) {
      return ''
    }
    const buttonInfo = this._fabButton
    const bAnimate = buttonInfo.animateOnce
    if (buttonInfo.visible && bAnimate) {
      this._fabButton.animateOnce = false
    }
    const buttonTitle = `common.list.${this._pageIdent.replace(
      /-/g,
      ''
    )}AddButton`
    const _className = `${this._pageIdent.replace(/-/g, '')}-addbutton`

    return (
      <AddButton
        title={buttonTitle}
        ref={this._basePageReferences.refFABButton}
        className={_className}
        hidden={!buttonInfo.visible}
        animate={bAnimate}
        onCloseClick={buttonInfo.hasClose ? this._onFABClose.bind(this) : null}
        onClick={this._onFABClick.bind(this)}
        size={this._buttonSize}
      />
    )
  }

  _setFABButtonState (bShow, bHasClose) {
    this._fabButton.required = bShow
    this._fabButton.hasClose = bHasClose
    if (this._fabButton.required) {
      FabButtonManager.setEventListener(bVisible => {
        this._toggleFABButton(bVisible)
      })
    } else {
      FabButtonManager.clearEventListener()
    }
  }

  _setFABButtonVisible (bVisible) {
    this._fabButton.visible = bVisible
  }

  _onFABClose (ev) {
    ev.preventDefault()
    if (
      this._fabButton.hasClose &&
      this._basePageReferences.refFABButton.current
    ) {
      this._basePageReferences.refFABButton.current.hideCloseAdd()
    }
    if (this.onFABClose) {
      this.onFABClose()
    }
  }

  onFABClose () {}
  onAdd () {}

  _toggleDemoButton (bVisible) {
    if (this._basePageReferences.refDemoButton.current) {
      if (bVisible) {
        this._basePageReferences.refDemoButton.current.show()
      } else {
        this._basePageReferences.refDemoButton.current.hide()
      }
    }
  }

  _toggleFABButton (bVisible) {
    if (
      this._fabButton.required &&
      this._fabButton.visible &&
      this._basePageReferences.refFABButton.current
    ) {
      if (bVisible) {
        this._basePageReferences.refFABButton.current.show()
      } else {
        if (this._basePageReferences.refFABButton.current) {
          this._basePageReferences.refFABButton.current.hide()
        }
      }
    }
  }

  _hideCloseFABButton () {
    if (
      this._fabButton.hasClose &&
      this._basePageReferences.refFABButton.current
    ) {
      this._basePageReferences.refFABButton.current.hideCloseAdd()
    }
  }

  _onFABClick (ev) {
    ev.preventDefault()
    if (
      this._fabButton.hasClose &&
      this._basePageReferences.refFABButton.current
    ) {
      this._basePageReferences.refFABButton.current.showCloseAdd()
    }
    if (this.onAdd) {
      this.onAdd()
    }
  }

  /* Reload realtime related functions */
  _initRealTimeVariables () {
    this._isDataLoading = false
    this._lastReloadTime = null
    this._reloadDiffTime = 1000 // 1 second
  }

  _setDataLoading () {
    this._isDataLoading = true
  }

  _setDataLoaded () {
    this._isDataLoading = false
    this._lastReloadTime = Date.now()
  }

  _canRealTimeReload () {
    // Dont reload if any data is under loading
    // Dont reload with 1 second of previous reload
    if (
      !this._isDataLoading &&
      (this._lastReloadTime === null ||
        Date.now() - this._lastReloadTime >= this._reloadDiffTime)
    ) {
      return true
    }
    return false
  }

  /* Init socket connection events */
  _initSocketConnectionEvents () {
    ConnectionUtil.initSocketConnectionEvents(this._onReconnect.bind(this))
  }

  _releaseSocketConnectionEvents () {
    ConnectionUtil.releaseSocketConnectionEvents()
  }

  // TODO: This block needs refactoring or other attention.
  /* eslint-disable */
  _loadFbq () {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js')
  }
  /* eslint-enable */

  _validatePassword (email, password, callback) {
    const userParams = {
      query: {
        email: email,
        password: password
      }
    }

    app
      .service('/api/users/validatepassword')
      .find(userParams)
      .then(userRes => {
        if (userRes) {
          callback(userRes)
        } else {
          callback(null)
        }
      })
      .catch(err => {
        app.debug('PageUserProfile: _validatePassword Error', err)
        callback(null)
      })
  }
}

export default PageBase
